import pdfMake from "pdfmake"
import pdfFonts from "@/fonts/cordiaUPC"
import imageK from '@/image/imageBase64.json'
import dateFunction from './formatDateTothai'

function printReserveLname(pid, fullname, reservename, docno, reservDate, redCossDate) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs

  pdfMake.fonts = {
    CordiaUPC: {
      normal: "CordiaUPC.ttf",
      bold: "CordiaUPC-Bold.ttf",
      italics: "CordiaUPC-Italic.ttf",
      bolditalics: "CordiaUPC-BoldItalic.ttf",
    },
  }

  var yearPrint = redCossDate.substring(0, 2)
  return {
    pageSize: 'A4',
    // การใช้ฟังกฺชัน header แสดงทุกหน้า โดยความสูงจะไม่เกิน 60px
    header(currentPage, pageCount, pageSize) {
      return [{
        stack: [{
          width: 75,
          hight: 75,
          image: imageK.krut,
          alignment: 'center',
          margin: [0, 30, 0, 0]
        }]
      }]
    },
    content: [
      // การปรับ margin [ ซ้าย, บน, ขวา, ล่าง ]
      // ข้อความอิงตามขอบกระดาษที่กำหนด
      {
        text: 'หนังสือรับรองการจองชื่อสกุล',
        style: 'big',
        alignment: 'center',
        margin: [0, 80, 0, 0],
        bold: true
      },
      // วางข้อความแบบ fixed ตำแหน่งของกระดาษ อิงตามแกน x,y (แนะนำให้วางไว้บนสุด ไม่งั้น position จะเพี้ยน)
      // วางข้อความปกติ บรรทัด 1
      {
        text: dateFunction.formatNumberToThai('ที่ ' + docno + '/25' + yearPrint),
        style: 'normal',
        margin: [0, 15, 0, 0],
        bold: false
      },
      // วางข้อความปกติ บรรทัด 2
      {
        text: 'ส่วนการทะเบียนทั่วไป สำนักบริหารการทะเบียน กรมการปกครอง',
        style: 'normal',
        margin: [300, -16, 0, 0],
        bold: false
      },
      // วางข้อความปกติ บรรทัด 3
      {
        text: 'วันที่ ' + dateFunction.formatNumberToThai(dateFunction.formatDateToThaiString(reservDate)),
        style: 'normal',
        margin: [250, 4, 0, 0],
        bold: false
      },

      // {
      //   text: 'ฝ่ายทะเบียนชื่อบุคคล กลุ่มงานบริหารงานทะเบียนสิทธิและสถานภาพบุคคล ส่วนการทะเบียนทั่วไป',
      //   style: 'normal',
      //   margin: [50, 20, 0, 0],
      //   bold: false
      // },
      // {
      //   text: 'สำนักบริหารการทะบียน กรมการปกครอง ได้ตรวจสอบคุณสมบัติของ ',
      //   style: 'normal',
      //   margin: [0, 4, 0, 0],
      //   bold: false
      // },
      // {
      //   text: fullname,
      //   style: 'normal',
      //   relativePosition: {
      //     x: 265,
      //     y: -16
      //   },
      //   bold: true
      // },
      // // แปลงวันที่
      // {
      //   text: 'เลขประจำตัวประชาชน ',
      //   style: 'normal',
      //   margin: [0, 4, 0, 0],
      //   bold: false
      // },
      // {
      //   text: dateFunction.formatPid(pid),
      //   style: 'normal',
      //   relativePosition: {
      //     x: 100,
      //     y: -16
      //   },
      //   bold: true
      // },
      {
        text: `${fullname} เลขประจำตัวประชาชน ${dateFunction.formatNumberToThai(dateFunction.formatPid(pid))}`,
        style: 'normal',
        margin: [0, 25, 0, 0],
        alignment: 'center',
        bold: true
      },
      {
        text: "มีความประสงค์ขอจองชื่อสกุล",
        style: 'normal',
        alignment: 'center',
        margin: [0, 0, 0, 0],
        bold: false
      },
      // วางข้อความซ้อนบรรทัดใช้ relativePosition อิงตามแกน x,y ปรับช่องไฟตามความเหมาะสม
      {
        text: reservename,
        style: 'normal',
        alignment: 'center',
        relativePosition: {
          x: 0,
          y: 25
        },
        bold: true
      },
      {
        text: ".....................................................................................",
        style: 'normal',
        alignment: 'center',
        margin: [0, 28, 0, 0],
        bold: false
      },
      {
        text: `ส่วนการทะเบียนทั่วไป สำนักบริหารการทะเบียน กรมการปกครอง ได้ตรวจสอบชื่อสกุลดังกล่าว`,
        style: "normal",
        margin: [87, 25, 0, 0],
        bold: false
      },
      {
        text: `แล้วถูกต้องตามพระราชบัญญัติชื่อบุคคล พ.ศ.๒๕๐๕ จึงกำหนดให้ผู้ที่ได้รับหนังสือรับรองการจองชื่อสกุล`,
        style: "normal",
        margin: [45, 0, 0, 0],
        bold: false
      },
      {
        text: `ตามโครงการให้บริการด้านทะเบียนในงานกาชาด  ประจำปี  ๒๕๖๗  ฉบับนี้  ไปยื่นคำขอจดทะเบียน`,
        style: "normal",
        margin: [45, 0, 0, 0],
        bold: false
      },
      {
        text: `ตั้งชื่อสกุลต่อนายทะเบียนท้องที่  ณ  ที่ว่าการอำเภอหรือสำนักงานเขตที่ตนมีชื่ออยู่ในทะเบียนบ้าน`,
        style: "normal",
        margin: [45, 0, 0, 0],
        bold: false
      },
      // {
      //   text: `ภายใน `,
      //   style: "normal",
      //   margin: [454, -17, 0, 0],
      //   bold: true, // Bold text
      // },
      {
        text: `ภายใน ๙๐ วัน `,
        style: "normal",
        margin: [45, 0, 0, 0],
        bold: true, // Bold text
      },
      {
        text: `หากพ้นระยะเวลาดังกล่าวถือว่าผู้นั้นสละสิทธิ์ในการจองชื่อสกุลข้างต้น`,
        style: "normal",
        margin: [117, -19, 0, 0],
        bold: false
      },
    ],
    footer() {
      return [
        {
          text: 'หมายเหตุ :',
          style: 'normal',
          margin: [100, -100, 50, 0], 
          bold: true,
        },
        {
          text: 'หากมีข้อสงสัยสามารถสอบถามข้อมูลเพิ่มเติมได้ที่ ฝ่ายทะเบียนชื่อบุคคล กลุ่มงาน',
          style: 'normal',
          margin: [150, -17, 50, 0], // Consistent margins for alignment
        },
        {
          text: dateFunction.formatNumberToThai('บริหารงานทะเบียนสิทธิและสถานภาพบุคคล โทร. 0 2791 7048 - 9'),
          style: 'normal',
          margin: [100, 4, 50, 10], // Bottom margin to separate from page border
        },
      ];
    },
    defaultStyle: {
      font: "CordiaUPC",
    },
    styles: {
      big: {
        fontSize: 18
      },
      normal: {
        fontSize: 16
      },
      small: {
        fontSize: 12
      },
      header: {
        fontSize: 20,
        bold: true,
        alignment: 'center'
        //   margin: [0, 10, 0, 0]
      },
      footer: {
        fontSize: 16,
        alignment: 'left',
        margin: [60, 0, 0, 0]
      },
      tableBody: {
        fontSize: 14
      },
      headerTable: {
        alignment: 'center',
        bold: true,
        fontSize: '14',
        margin: [200, 20, 0, 10]
      },
      bodyTable: {
        alignment: 'center'
      }
    }
  }
}

export default ({
  printReserveLname,
  data() {
    return {
      // imageb64,
    }
  }
})
